import { takeLatest, all, call, put, select } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';
import { enums } from 'console-kit';

import { Experience, Account } from 'common-entities';

import EmailIntegrationsActions from '../actions';
import EmailIntegrationsApi from '../email-integrations-api';

function* fetchTemplateNotificationListHandler() {
  try {
    const experience = yield select(Experience.Selectors.experience);
    const response = yield call(EmailIntegrationsApi.fetchTemplateEmailList, experience);
    yield put(EmailIntegrationsActions.setEmailTemplatePickerList(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.templateEmailListFetchFail(error));
  }
}

function* addNewNotificationHandler({ payload: { emailTemplateId } }) {
  const account = yield select(Account.Selectors.activeAccount);
  const experience = yield select(Experience.Selectors.experience);

  try {
    const { response } = yield all({
      pause:       delay(500),
      pickerState: put(EmailIntegrationsActions.updateTemplatePickerState(enums.pickerStates.LOADING)),
      response:    call(EmailIntegrationsApi.fetchNewEmailTemplate, emailTemplateId, experience.id, account.id),
    });

    yield all({
      // using delay here as a minimum duration for the API call to ensure the UI state transitions properly
      pause:       delay(750),
      pickerState: put(EmailIntegrationsActions.updateTemplatePickerState(enums.pickerStates.DEFAULT)),
    });

    yield put(EmailIntegrationsActions.closeEmailTemplatePicker());
    yield put(EmailIntegrationsActions.addNewNotificationToLocalList(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.fetchNewEmailTemplateFail(error));
  }
}

function* openEmailTemplatePickerHandler() {
  yield put(EmailIntegrationsActions.fetchTemplateNotificationList());
}

export default function* templatePickerSaga() {
  yield all([
    takeLatest(EmailIntegrationsActions.addNewNotification.getType(), addNewNotificationHandler),
    takeLatest(EmailIntegrationsActions.fetchTemplateNotificationList.getType(), fetchTemplateNotificationListHandler),
    takeLatest(EmailIntegrationsActions.openEmailTemplatePicker.getType(), openEmailTemplatePickerHandler),
  ]);
}
